/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("sk", {
  Redo: "Znova",
  Undo: "Sp\u00e4\u0165",
  Cut: "Vystrihn\u00fa\u0165",
  Copy: "Kop\u00edrova\u0165",
  Paste: "Prilepi\u0165",
  "Select all": "Ozna\u010di\u0165 v\u0161etko",
  "New document": "Nov\u00fd dokument",
  Ok: "Ok",
  Cancel: "Zru\u0161i\u0165",
  "Visual aids": "Vizu\u00e1lne pom\u00f4cky",
  Bold: "Tu\u010dn\u00e9",
  Italic: "Kurz\u00edva",
  Underline: "Pod\u010diarknut\u00e9",
  Strikethrough: "Pre\u010diarknut\u00e9",
  Superscript: "Horn\u00fd index",
  Subscript: "Doln\u00fd index",
  "Clear formatting": "Vymaza\u0165 form\u00e1tovanie",
  "Align left": "Zarovna\u0165 v\u013eavo",
  "Align center": "Zarovna\u0165 na stred",
  "Align right": "Zarovna\u0165 vpravo",
  Justify: "Zarovna\u0165",
  "Bullet list": "Zoznam s odr\u00e1\u017ekami",
  "Numbered list": "\u010c\u00edslovan\u00fd zoznam",
  "Decrease indent": "Zmen\u0161i\u0165 odsadenie",
  "Increase indent": "Zv\u00e4\u010d\u0161i\u0165 odsadenie",
  Close: "Zatvori\u0165",
  Formats: "Form\u00e1ty",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "V\u00e1\u0161 prehliada\u010d nepodporuje priamy pr\u00edstup do schr\u00e1nky. Pou\u017eite kl\u00e1vesov\u00e9 skratky Ctrl+X/C/V.",
  Headers: "Z\u00e1hlavia",
  "Header 1": "Z\u00e1hlavie 1",
  "Header 2": "Z\u00e1hlavie 2",
  "Header 3": "Z\u00e1hlavie 3",
  "Header 4": "Z\u00e1hlavie 4",
  "Header 5": "Z\u00e1hlavie 5",
  "Header 6": "Z\u00e1hlavie 6",
  Headings: "Nadpisy",
  "Heading 1": "Nadpis 1",
  "Heading 2": "Nadpis 2",
  "Heading 3": "Nadpis 3",
  "Heading 4": "Nadpis 4",
  "Heading 5": "Nadpis 5",
  "Heading 6": "Nadpis 6",
  Preformatted: "Predform\u00e1tovan\u00e9",
  Div: "Div",
  Pre: "Pre",
  Code: "K\u00f3d",
  Paragraph: "Odstavec",
  Blockquote: "Blockquote",
  Inline: "Vlo\u017een\u00e9 \u0161t\u00fdly",
  Blocks: "Bloky",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "Vkladanie je v m\u00f3de neform\u00e1tovan\u00e9ho textu. Vkladan\u00fd obsah bude vlo\u017een\u00fd ako neform\u00e1tovan\u00fd, a\u017e pok\u00fdm t\u00fato mo\u017enos\u0165 nevypnete.",
  Fonts: "Typy p\u00edsma",
  "Font Sizes": "Ve\u013ekosti p\u00edsma",
  Class: "Trieda",
  "Browse for an image": "N\u00e1js\u0165 obr\u00e1zok",
  OR: "ALEBO",
  "Drop an image here": "Pretiahnite obr\u00e1zok sem",
  Upload: "Nahra\u0165",
  Block: "Blok",
  Align: "Zarovna\u0165",
  Default: "V\u00fdchodzie",
  Circle: "Kruh",
  Disc: "Disk",
  Square: "\u0160tvorec",
  "Lower Alpha": "Mal\u00e9 p\u00edsmen\u00e1",
  "Lower Greek": "Mal\u00e9 gr\u00e9cke p\u00edsmen\u00e1",
  "Lower Roman": "Mal\u00e9 r\u00edmske \u010d\u00edslice",
  "Upper Alpha": "Ve\u013ek\u00e9 p\u00edsmen\u00e1",
  "Upper Roman": "Ve\u013ek\u00e9 r\u00edmske \u010d\u00edslice",
  "Anchor...": "Kotva...",
  Name: "N\u00e1zov",
  Id: "Id",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "Id by malo za\u010d\u00edna\u0165 p\u00edsmenom, nasledovan\u00e9 p\u00edsmenami, \u010d\u00edslami, pom\u013a\u010dkami, bodkami, dvojbodkami alebo podtr\u017en\u00edkmi.",
  "You have unsaved changes are you sure you want to navigate away?":
    "M\u00e1te neulo\u017een\u00e9 zmeny, naozaj chcete opusti\u0165 str\u00e1nku?",
  "Restore last draft": "Obnovi\u0165 posledn\u00fd koncept",
  "Special character...": "\u0160peci\u00e1lny znak...",
  "Source code": "Zdrojov\u00fd k\u00f3d",
  "Insert/Edit code sample": "Vlo\u017ei\u0165/upravi\u0165 vzorku k\u00f3du",
  Language: "Jazyk",
  "Code sample...": "Vzorka k\u00f3du...",
  "Color Picker": "V\u00fdber farieb",
  R: "R",
  G: "G",
  B: "B",
  "Left to right": "Z\u013eava doprava",
  "Right to left": "Sprava do\u013eava",
  "Emoticons...": "Smajl\u00edky...",
  "Metadata and Document Properties": "Meta\u00fadaje a vlastnosti dokumentu",
  Title: "Nadpis",
  Keywords: "K\u013e\u00fa\u010dov\u00e9 slov\u00e1",
  Description: "Popis",
  Robots: "Preh\u013ead\u00e1vacie roboty",
  Author: "Autor",
  Encoding: "K\u00f3dovanie",
  Fullscreen: "Na cel\u00fa obrazovku",
  Action: "Action",
  Shortcut: "Shortcut",
  Help: "Help",
  Address: "Address",
  "Focus to menubar": "Focus to menubar",
  "Focus to toolbar": "Focus to toolbar",
  "Focus to element path": "Focus to element path",
  "Focus to contextual toolbar": "Focus to contextual toolbar",
  "Insert link (if link plugin activated)":
    "Insert link (if link plugin activated)",
  "Save (if save plugin activated)": "Save (if save plugin activated)",
  "Find (if searchreplace plugin activated)":
    "Find (if searchreplace plugin activated)",
  "Plugins installed ({0}):": "Plugins installed ({0}):",
  "Premium plugins:": "Premium plugins:",
  "Learn more...": "Learn more...",
  "You are using {0}": "You are using {0}",
  Plugins: "Pluginy",
  "Handy Shortcuts": "U\u017eito\u010dn\u00e9 odkazy",
  "Horizontal line": "Horizont\u00e1lna \u010diara",
  "Insert/edit image": "Vlo\u017ei\u0165/upravi\u0165 obr\u00e1zok",
  "Image description": "Popis obr\u00e1zku",
  Source: "Zdroj",
  Dimensions: "Rozmery",
  "Constrain proportions": "Vymedzen\u00e9 proporcie",
  General: "Hlavn\u00e9",
  Advanced: "Pokro\u010dil\u00e9",
  Style: "\u0160t\u00fdl",
  "Vertical space": "Vertik\u00e1lny priestor",
  "Horizontal space": "Horizont\u00e1lny priestor",
  Border: "Or\u00e1movanie",
  "Insert image": "Vlo\u017ei\u0165 obr\u00e1zok",
  "Image...": "Obr\u00e1zok...",
  "Image list": "Zoznam obr\u00e1zkov",
  "Rotate counterclockwise":
    "Oto\u010di\u0165 proti smeru hodinov\u00fdch ru\u010di\u010diek",
  "Rotate clockwise":
    "Oto\u010di\u0165 v smere hodinov\u00fdch ru\u010di\u010diek",
  "Flip vertically": "Preklopi\u0165 vertik\u00e1lne",
  "Flip horizontally": "Preklopi\u0165 horizont\u00e1lne",
  "Edit image": "Upravi\u0165 obr\u00e1zok",
  "Image options": "Mo\u017enosti obr\u00e1zku",
  "Zoom in": "Pribl\u00ed\u017ei\u0165",
  "Zoom out": "Oddiali\u0165",
  Crop: "Vyreza\u0165",
  Resize: "Zmeni\u0165 ve\u013ekos\u0165",
  Orientation: "Orient\u00e1cia",
  Brightness: "Jas",
  Sharpen: "Zaostri\u0165",
  Contrast: "Kontrast",
  "Color levels": "\u00darovne farieb",
  Gamma: "Gama",
  Invert: "Invertova\u0165",
  Apply: "Pou\u017ei\u0165",
  Back: "Sp\u00e4\u0165",
  "Insert date/time": "Vlo\u017ei\u0165 d\u00e1tum/\u010das",
  "Date/time": "D\u00e1tum/\u010das",
  "Insert/Edit Link": "Vlo\u017ei\u0165/Upravi\u0165 odkaz",
  "Insert/edit link": "Vlo\u017ei\u0165/upravi\u0165 odkaz",
  "Text to display": "Zobrazen\u00fd text",
  Url: "Url",
  "Open link in...": "Otvori\u0165 odkaz v...",
  "Current window": "Aktu\u00e1lne okno",
  None: "\u017diadne",
  "New window": "Nov\u00e9 okno",
  "Remove link": "Odstr\u00e1ni\u0165 odkaz",
  Anchors: "Kotvy",
  "Link...": "Odkaz...",
  "Paste or type a link": "Prilepte alebo nap\u00ed\u0161te odkaz",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "URL, ktor\u00fa ste vlo\u017eili je pravdepodobne emailov\u00e1 adresa. \u017del\u00e1te si prida\u0165 vy\u017eadovan\u00fa mailto: predponu?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "URL adresa ktor\u00fa ste zadali vyzer\u00e1 ako extern\u00fd odkaz. Chcete prida\u0165 vy\u017eadovan\u00fa http:// predponu?",
  "Link list": "Zoznam odkazov",
  "Insert video": "Vlo\u017ei\u0165 video",
  "Insert/edit video": "Vlo\u017ei\u0165/upravi\u0165 video",
  "Insert/edit media": "Vlo\u017ei\u0165/upravi\u0165 m\u00e9di\u00e1",
  "Alternative source": "Alternat\u00edvny zdroj",
  "Alternative source URL": "Alternat\u00edvny zdroj URL",
  "Media poster (Image URL)": "Obr\u00e1zok m\u00e9dia (URL obr\u00e1zka)",
  "Paste your embed code below:":
    "Vlo\u017ete k\u00f3d pre vlo\u017eenie na str\u00e1nku:",
  Embed: "Vlo\u017een\u00e9",
  "Media...": "M\u00e9di\u00e1...",
  "Nonbreaking space": "Nedelite\u013en\u00e1 medzera",
  "Page break": "Zalomenie str\u00e1nky",
  "Paste as text": "Vlo\u017ei\u0165 ako text",
  Preview: "N\u00e1h\u013ead",
  "Print...": "Tla\u010d...",
  Save: "Ulo\u017ei\u0165",
  Find: "H\u013eada\u0165",
  "Replace with": "Nahradi\u0165 za",
  Replace: "Nahradi\u0165",
  "Replace all": "Nahradi\u0165 v\u0161etko",
  Previous: "Predch\u00e1dzaj\u00face",
  Next: "Nasleduj\u00face",
  "Find and replace...": "N\u00e1js\u0165 a nahradi\u0165...",
  "Could not find the specified string.":
    "Zadan\u00fd re\u0165azec sa nena\u0161iel.",
  "Match case": "Rozli\u0161ova\u0165 ve\u013ek\u00e9/mal\u00e9",
  "Find whole words only": "H\u013eada\u0165 len cel\u00e9 slov\u00e1",
  "Spell check": "Kontrola pravopisu",
  Ignore: "Ignorova\u0165",
  "Ignore all": "Ignorova\u0165 v\u0161etko",
  Finish: "Dokon\u010di\u0165",
  "Add to Dictionary": "Prida\u0165 do slovn\u00edka",
  "Insert table": "Vlo\u017ei\u0165 tabu\u013eku",
  "Table properties": "Nastavenia tabu\u013eky",
  "Delete table": "Zmaza\u0165 tabu\u013eku",
  Cell: "Bunka",
  Row: "Riadok",
  Column: "St\u013apec",
  "Cell properties": "Vlastnosti bunky",
  "Merge cells": "Spoji\u0165 bunky",
  "Split cell": "Rozdeli\u0165 bunku",
  "Insert row before": "Vlo\u017ei\u0165 nov\u00fd riadok pred",
  "Insert row after": "Vlo\u017ei\u0165 nov\u00fd riadok za",
  "Delete row": "Zmaza\u0165 riadok",
  "Row properties": "Vlastnosti riadku",
  "Cut row": "Vystrihn\u00fa\u0165 riadok",
  "Copy row": "Kop\u00edrova\u0165 riadok",
  "Paste row before": "Vlo\u017ei\u0165 riadok pred",
  "Paste row after": "Vlo\u017ei\u0165 riadok za",
  "Insert column before": "Prida\u0165 nov\u00fd st\u013apec pred",
  "Insert column after": "Prida\u0165 nov\u00fd st\u013apec za",
  "Delete column": "Vymaza\u0165 st\u013apec",
  Cols: "St\u013apce",
  Rows: "Riadky",
  Width: "\u0160\u00edrka",
  Height: "V\u00fd\u0161ka",
  "Cell spacing": "Priestor medzi bunkami",
  "Cell padding": "Odsadenie v bunk\u00e1ch",
  "Show caption": "Zobrazi\u0165 popis",
  Left: "V\u013eavo",
  Center: "Na stred",
  Right: "Vpravo",
  "Cell type": "Typ bunky",
  Scope: "Oblas\u0165",
  Alignment: "Zarovnanie",
  "H Align": "Horizont\u00e1lne zarovnanie",
  "V Align": "Vertik\u00e1lne zarovnanie",
  Top: "Vrch",
  Middle: "Stred",
  Bottom: "Spodok",
  "Header cell": "Bunka z\u00e1hlavia",
  "Row group": "Skupina riadkov",
  "Column group": "Skupina st\u013apcov",
  "Row type": "Typ riadku",
  Header: "Z\u00e1hlavie",
  Body: "Telo",
  Footer: "P\u00e4ti\u010dka",
  "Border color": "Farba or\u00e1movania",
  "Insert template...": "Vlo\u017ei\u0165 \u0161abl\u00f3nu...",
  Templates: "\u0160abl\u00f3ny",
  Template: "\u0160abl\u00f3na",
  "Text color": "Farba textu",
  "Background color": "Farba pozadia",
  "Custom...": "Vlastn\u00e1...",
  "Custom color": "Vlastn\u00e1 farba",
  "No color": "Bez farby",
  "Remove color": "Odstr\u00e1ni\u0165 farbu",
  "Table of Contents": "Obsah",
  "Show blocks": "Zobrazi\u0165 bloky",
  "Show invisible characters": "Zobrazi\u0165 skryt\u00e9 znaky",
  "Word count": "Po\u010det slov",
  Count: "Po\u010det",
  Document: "Dokument",
  Selection: "V\u00fdber",
  Words: "Slov\u00e1",
  "Words: {0}": "Slov: {0}",
  "{0} words": "{0} slov\u00e1/slov",
  File: "S\u00fabor",
  Edit: "Upravi\u0165",
  Insert: "Vlo\u017ei\u0165",
  View: "Zobrazi\u0165",
  Format: "Form\u00e1t",
  Table: "Tabu\u013eka",
  Tools: "N\u00e1stroje",
  "Powered by {0}": "Pou\u017e\u00edva {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Textov\u00e9 pole. Stla\u010dte ALT-F9 pre zobrazenie menu, ALT-F10 pre zobrazenie panela n\u00e1strojov, ALT-0 pre n\u00e1povedu.",
  "Image title": "N\u00e1zov obr\u00e1zka",
  "Border width": "\u0160\u00edrka okraja",
  "Border style": "\u0160t\u00fdl okraja",
  Error: "Chyba",
  Warn: "Upozornenie",
  Valid: "Platn\u00e9",
  "To open the popup, press Shift+Enter":
    "Na otvorenie kontextovej ponuky stla\u010dte Shift+Enter",
  "Rich Text Area. Press ALT-0 for help.":
    "Oblas\u0165 pre text vo form\u00e1te RTF. Stla\u010dte ALT-0 pre n\u00e1povedu.",
  "System Font": "Syst\u00e9mov\u00e9 p\u00edsmo",
  "Failed to upload image: {0}": "Obr\u00e1zok sa nepodarilo nahra\u0165: {0}",
  "Failed to load plugin: {0} from url {1}":
    "Plugin: {0} sa nepodarilo nahra\u0165 z url {1}",
  "Failed to load plugin url: {0}": "Nepodarilo sa nahra\u0165 plugin url: {0}",
  "Failed to initialize plugin: {0}":
    "Nepodarilo sa inicializova\u0165 plugin: {0}",
  example: "pr\u00edklad",
  Search: "Vyh\u013eada\u0165",
  All: "V\u0161etko",
  Currency: "Mena",
  Text: "Text",
  Quotations: "Kvot\u00e1cie",
  Mathematical: "Matematick\u00e9",
  "Extended Latin": "Roz\u0161\u00edren\u00e1 latinka",
  Symbols: "Symboly",
  Arrows: "\u0160\u00edpky",
  "User Defined": "Definovan\u00e9 pou\u017e\u00edvate\u013eom",
  "dollar sign": "znak pre dol\u00e1r",
  "currency sign": "znak meny",
  "euro-currency sign": "znak eura",
  "colon sign": "znak dvojbodky",
  "cruzeiro sign": "znak pre cruzeiro",
  "french franc sign": "znak pre franc\u00fazsky frank",
  "lira sign": "znak pre l\u00edru",
  "mill sign": "znak pre mill",
  "naira sign": "znak pre nairu",
  "peseta sign": "znak pre pesetu",
  "rupee sign": "znak pre rupiu",
  "won sign": "znak pre won",
  "new sheqel sign": "znak pre nov\u00fd \u0161ekel",
  "dong sign": "znak pre dong",
  "kip sign": "znak pre kip",
  "tugrik sign": "znak pre tugrik",
  "drachma sign": "znak pre drachmu",
  "german penny symbol": "znak pre nemeck\u00fd pfennig",
  "peso sign": "znak pre peso",
  "guarani sign": "znak pre guarani",
  "austral sign": "znak pre austral",
  "hryvnia sign": "znak pre hrivnu",
  "cedi sign": "znak pre cedi",
  "livre tournois sign": "znak pre livre tournois",
  "spesmilo sign": "znak pre spesmilo",
  "tenge sign": "znak pre tenge",
  "indian rupee sign": "znak pre indick\u00fa rupiu",
  "turkish lira sign": "znak pre tureck\u00fa l\u00edru",
  "nordic mark sign": "znak pre nordick\u00fa marku",
  "manat sign": "znak pre manat",
  "ruble sign": "znak pre rube\u013e",
  "yen character": "znak pre jen",
  "yuan character": "znak pre j\u00fcan",
  "yuan character, in hong kong and taiwan":
    "znak pre j\u00fcan, v Hongkongu a Taiwane",
  "yen/yuan character variant one": "znak pre jen/j\u00fcan variant jedna",
  "Loading emoticons...": "Na\u010d\u00edtavam smajl\u00edky...",
  "Could not load emoticons":
    "Smajl\u00edky sa nepodarilo na\u010d\u00edta\u0165",
  People: "\u013dudia",
  "Animals and Nature": "Zvierat\u00e1 a pr\u00edroda",
  "Food and Drink": "Jedlo a n\u00e1poje",
  Activity: "Aktivity",
  "Travel and Places": "Cestovanie a miesta",
  Objects: "Objekty",
  Flags: "Vlajky",
  Characters: "Znaky",
  "Characters (no spaces)": "Znaky (bez medzier)",
  "{0} characters": "Znaky: {0}",
  "Error: Form submit field collision.":
    "Chyba: konflikt po\u013ea odosielania formul\u00e1ra.",
  "Error: No form element found.":
    "Chyba: nena\u0161iel sa prvok formul\u00e1ra.",
  Update: "Aktualizova\u0165",
  "Color swatch": "Vzorky farieb",
  Turquoise: "Tyrkysov\u00e1",
  Green: "Zelen\u00e1",
  Blue: "Modr\u00e1",
  Purple: "Fialov\u00e1",
  "Navy Blue": "N\u00e1morn\u00edcka modr\u00e1",
  "Dark Turquoise": "Tmavotyrkysov\u00e1",
  "Dark Green": "Tmavozelen\u00e1",
  "Medium Blue": "Stredn\u00e1 modr\u00e1",
  "Medium Purple": "Stredn\u00e1 fialov\u00e1",
  "Midnight Blue": "Polno\u010dn\u00e1 modr\u00e1",
  Yellow: "\u017dlt\u00e1",
  Orange: "Oran\u017eov\u00e1",
  Red: "\u010cerven\u00e1",
  "Light Gray": "Svetlosiv\u00e1",
  Gray: "Siv\u00e1",
  "Dark Yellow": "Tmavo\u017elt\u00e1",
  "Dark Orange": "Tmavooran\u017eov\u00e1",
  "Dark Red": "Tmavo\u010derven\u00e1",
  "Medium Gray": "Stredn\u00e1 siv\u00e1",
  "Dark Gray": "Tmavosiv\u00e1",
  "Light Green": "Svetlozelen\u00e1",
  "Light Yellow": "Svetlo\u017elt\u00e1",
  "Light Red": "Svetlo\u010derven\u00e1",
  "Light Purple": "Svetlofialov\u00e1",
  "Light Blue": "Svetlomodr\u00e1",
  "Dark Purple": "Tmavofialov\u00e1",
  "Dark Blue": "Tmavomodr\u00e1",
  Black: "\u010cierna",
  White: "Biela",
  "Switch to or from fullscreen mode":
    "Prepn\u00fa\u0165 do alebo z re\u017eimu plnej obrazovky",
  "Open help dialog": "Otvori\u0165 okno n\u00e1povedy",
  history: "hist\u00f3ria",
  styles: "\u0161t\u00fdly",
  formatting: "form\u00e1tovanie",
  alignment: "zarovnanie",
  indentation: "odsadenie",
  "permanent pen": "fixka",
  comments: "koment\u00e1re",
  "Format Painter": "Kop\u00edrova\u0165 form\u00e1t",
  "Insert/edit iframe": "Vlo\u017ei\u0165/upravi\u0165 iframe",
  Capitalization: "Ve\u013ek\u00e9 p\u00edsmen\u00e1",
  lowercase: "mal\u00e9 p\u00edsmen\u00e1",
  UPPERCASE: "V\u0160ETKY P\u00cdSMEN\u00c1 VE\u013dK\u00c9",
  "Title Case": "Prv\u00e9 P\u00edsmen\u00e1 Ve\u013ek\u00e9",
  "Permanent Pen Properties": "Vlastnosti fixky",
  "Permanent pen properties...": "Vlastnosti fixky...",
  Font: "P\u00edsmo",
  Size: "Ve\u013ekos\u0165",
  "More...": "Viac...",
  "Spellcheck Language": "Jazyk kontroly pravopisu",
  "Select...": "Vyberte...",
  Preferences: "Preferencie",
  Yes: "\u00c1no",
  No: "Nie",
  "Keyboard Navigation": "Navig\u00e1cia pomocou kl\u00e1vesnice",
  Version: "Verzia",
  Anchor: "Odkaz",
  "Special character": "\u0160peci\u00e1lny znak",
  Color: "Farba",
  Emoticons: "Smajl\u00edci",
  "Document properties": "Vlastnosti dokumentu",
  Image: "Obr\u00e1zok",
  "Insert link": "Vlo\u017ei\u0165 odkaz",
  Target: "Cie\u013e",
  Link: "Odkaz",
  Poster: "Uk\u00e1\u017eka",
  Media: "M\u00e9di\u00e1",
  Print: "Tla\u010di\u0165",
  Prev: "Predch\u00e1dzaj\u00face",
  "Find and replace": "Vyh\u013eada\u0165 a nahradi\u0165",
  "Whole words": "Cel\u00e9 slov\u00e1",
  Spellcheck: "Kontrola pravopisu",
  Caption: "Popisok",
  "Insert template": "Vlo\u017ei\u0165 \u0161abl\u00f3nu",
});
